import { useCallback } from 'react';
import { useOrg } from './context';

/**
 * Resolves where to send a freshly-authenticated user: the org landing (`/`) when
 * they have at least one org, or the first-run `/getting-started` guide (whose
 * step 1 is creating the org) when they have none.
 *
 * It re-fetches memberships so the decision is deterministic at call time (the
 * OrgProvider's own load may still be in flight right after login). On a load
 * failure it defaults to `/`, where RequireOrg surfaces a retryable error UI
 * rather than silently routing to create-org.
 */
export function usePostAuthRedirect(): () => Promise<string> {
  const { refresh } = useOrg();
  return useCallback(async () => {
    try {
      const orgs = await refresh();
      return orgs.length > 0 ? '/' : '/getting-started';
    } catch {
      return '/';
    }
  }, [refresh]);
}
